export const FILE_NAME_TRUNCATE_LENGTH = 30;
export const APPLICATION_ROUTER_LINK_BASE = 'application';
export const NOI_ROUTER_LINK_BASE = 'notice-of-intent';
export enum DialogAction {
  ADD = 'add',
  EDIT = 'edit',
}
